import { ReactElement } from "react";
import cn from "classnames";

import styles from "./AscVoiceRecorder.module.scss";

export type IconButtonProps = React.ComponentProps<"button"> & {
  children: ReactElement;
  size?: "small" | "medium" | "large";
  clickable?: boolean;
};

export const IconButton = ({
  children,
  size = "medium",
  clickable = true,
  className,
  ...props
}: IconButtonProps) => (
  <button
    type="button"
    className={cn(styles.btn, {
      [styles.small]: size === "small",
      [styles.medium]: size === "medium",
      [styles.large]: size === "large",
      [styles.clickable]: clickable,
    })}
    onClick={(e) => clickable && props.onClick && props.onClick(e)}
    {...props}
  >
    {children}
  </button>
);
